/*
 * Keep Safari's root scroller intact while a mobile menu or dialog is open.
 * Lock background gestures, not html/body overflow or positioning. The drawer
 * keeps its internal scrolling, focus handling, links, controls and pinch zoom.
 */
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  let lastTouch = null;

  function activeDrawer() {
    if (!mobile.matches) return null;
    const dialogs = document.querySelectorAll('dialog[open]');
    if (dialogs.length) return dialogs[dialogs.length - 1];
    return null;
  }

  function elementTarget(target) {
    return target instanceof Element ? target : target?.parentElement;
  }

  function canScroll(target, drawer, deltaX, deltaY) {
    if (!target || !drawer.contains(target)) return false;
    const horizontal = Math.abs(deltaX) > Math.abs(deltaY);
    const delta = horizontal ? deltaX : deltaY;
    if (!delta) return true;

    for (let node = target; node && drawer.contains(node); node = node.parentElement) {
      const style = getComputedStyle(node);
      const overflow = horizontal ? style.overflowX : style.overflowY;
      if (!/^(auto|scroll)$/.test(overflow)) continue;
      const position = horizontal ? node.scrollLeft : node.scrollTop;
      const extent = horizontal
        ? node.scrollWidth - node.clientWidth
        : node.scrollHeight - node.clientHeight;
      if (extent > 1 && ((delta < 0 && position > 0) || (delta > 0 && position < extent - 1))) {
        return true;
      }
    }
    return false;
  }

  document.addEventListener('touchstart', (event) => {
    lastTouch = event.touches.length === 1
      ? { x: event.touches[0].clientX, y: event.touches[0].clientY }
      : null;
  }, { capture: true, passive: true });

  document.addEventListener('touchmove', (event) => {
    const previous = lastTouch;
    if (event.touches.length !== 1) {
      lastTouch = null;
      return;
    }
    const touch = event.touches[0];
    lastTouch = { x: touch.clientX, y: touch.clientY };
    const drawer = activeDrawer();
    if (!drawer || !previous) return;
    if (!canScroll(elementTarget(event.target), drawer, previous.x - touch.clientX, previous.y - touch.clientY)) {
      if (event.cancelable) event.preventDefault();
    }
  }, { capture: true, passive: false });

  function clearTouch() {
    lastTouch = null;
  }
  document.addEventListener('touchend', clearTouch, { passive: true });
  document.addEventListener('touchcancel', clearTouch, { passive: true });
  window.addEventListener('pageshow', clearTouch);

  document.addEventListener('wheel', (event) => {
    // Ctrl-wheel is trackpad/browser zoom; leave it available.
    if (event.ctrlKey) return;
    const drawer = activeDrawer();
    if (drawer && !canScroll(elementTarget(event.target), drawer, event.deltaX, event.deltaY)) {
      if (event.cancelable) event.preventDefault();
    }
  }, { capture: true, passive: false });

  document.addEventListener('keydown', (event) => {
    const drawer = activeDrawer();
    if (!drawer || event.ctrlKey || event.metaKey || event.altKey) return;
    const target = elementTarget(event.target);
    // Preserve editing, selection, range controls and native Space activation.
    if (target?.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"])')) return;
    if (event.key === ' ' && target?.closest('button, summary, [role="button"]')) return;
    const delta = {
      ArrowUp: -1, ArrowDown: 1, PageUp: -1, PageDown: 1,
      Home: -Infinity, End: Infinity, ' ': event.shiftKey ? -1 : 1,
    }[event.key];
    if (delta === undefined) return;
    if (!canScroll(target, drawer, 0, delta)) event.preventDefault();
  }, true);
})();
